import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import type { UpdateBookingVoucherForm } from 'app/typings/core/admin/bookings/bookingForm';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useUpdateBookingVoucher(
  bookingCode: string,
  voucherCode?: string
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: !!voucherCode
      ? async (payload: UpdateBookingVoucherForm) =>
          apiMutation(
            'PATCH',
            {
              path: ENDPOINTS.updateOrDeleteBookingVoucher,
              params: { bookingCode, voucherCode },
            },
            payload
          ) as Promise<void>
      : async () => {
          /* no-op */
        },
    onSuccess: () => {
      message.success('Voucher updated');

      queryClient.invalidateQueries([
        CORE_QUERY_KEYS.booking,
        { code: bookingCode },
      ]);
    },
    onError: () => {
      message.error('Failed to update voucher');
    },
  });
}
